import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Container,
  Paper,
  Box,
  Typography,
  Button,
  Alert,
} from "@mui/material";
import { verifyEmail } from "../services/api";

export default function VerifyEmailPage() {
  const location = useLocation();
  const [message, setMessage] = useState("Verifying your email...");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setError("Invalid verification link.");
      return;
    }

    verifyEmail(token)
      .then((res) => {
        if (res.data?.message) {
          setSuccess(res.data.message);
        } else {
          setError("Verification failed.");
        }
      })
      .catch(() => {
        setError("Something went wrong. Please try again.");
      });
  }, [location]);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
        <Typography variant="h5" mb={2} textAlign="center">
          Email Verification
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        {!error && !success && (
          <Alert severity="info" sx={{ mb: 2 }}>{message}</Alert>
        )}

        <Box textAlign="center" mt={3}>
          <Button variant="contained" href="/" sx={{ mt: 2 }}>
            Go to Login
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
